// extracted by mini-css-extract-plugin
export default {"image":"image--rhrF9"};